import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { VideoPreviewType } from '../utils/Types';
import playButton from '../assets/img/play-button.svg';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import VideoPlayerModal from './VideoPlayerModal';
import { formattedDateWithFormat } from '../utils/Util';
import defaultVideoThumbnail from '../assets/img/video-thumbnail.jpg';

interface IVideoPreviewProps {
  video: VideoPreviewType;
  handleRemove: (param: number | string) => void;
  cancelWithBg?: boolean;
}

const VideoPreview: React.FunctionComponent<IVideoPreviewProps> = ({
  video,
  handleRemove,
  cancelWithBg = false,
}) => {
  const [playVideo, setPlayVideo] = useState(false);
  return (
    <>
      <div className="uploaded-file-card d-flex align-items-center">
        <CloseIcon
          className={`remove-file-icon${cancelWithBg ? '-bg p-1' : ''} `}
          onClick={() => handleRemove(video.id)}
        />
        <div className="file-preview-container me-2">
          <div className="file-preview-container">
            <div>
              <Image
                src={video.thumbnail || defaultVideoThumbnail}
                alt="Video"
                className="file-preview"
                onError={(e) => {
                  e.currentTarget.src = defaultVideoThumbnail;
                }}
              />
              <div className="play-button">
                <Image
                  src={playButton}
                  width={30}
                  height={30}
                  onClick={() => {
                    setPlayVideo(true);
                  }}
                  alt="play-button"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="file-details-container flex-grow-1">
          <div className="d-flex justify-content-between align-items-center pe-3">
            <p className="file-name mb-0">
              <OverlayTrigger
                placement="top-start"
                overlay={<Tooltip id={`id${video.id}`}>{video.name}</Tooltip>}
              >
                <span>{video.name}</span>
              </OverlayTrigger>
            </p>
          </div>
          <p className="file-size mb-0">
            Uploaded on:{' '}
            {formattedDateWithFormat(video.createdOn, 'DD-MM-YYYY hh:mm A')}
          </p>
          <p className="file-size mb-0">Order: {video?.order}</p>
        </div>
      </div>

      <VideoPlayerModal
        video={video}
        toggle={() => {
          setPlayVideo((prev) => !prev);
        }}
        isOpen={playVideo}
      />
    </>
  );
};

export default VideoPreview;
